import { render } from "./MeviusStoryScreen.vue?vue&type=template&id=0bfc8bb4&scoped=true&ts=true&lang=pug"
import script from "./MeviusStoryScreen.vue?vue&type=script&lang=ts"
export * from "./MeviusStoryScreen.vue?vue&type=script&lang=ts"

import "./MeviusStoryScreen.vue?vue&type=style&index=0&id=0bfc8bb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfc8bb4"]])

export default __exports__